/* AYO collection showcase (sections/ayo-collection-showcase.liquid) */
(function () {
  if (customElements.get('ayo-showcase')) return;
  class AyoShowcase extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-ayo-sc-list]');
      this.msg = this.querySelector('[data-ayo-sc-msg]');
      this.dialog = this.querySelector('[data-ayo-sc-dialog]');
      this.addEventListener('click', (e) => this.onClick(e));
      if (this.dialog) {
        this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); });
        this.dialog.addEventListener('close', () => document.documentElement.classList.remove('ayo-lock'));
      }
      if (this.dataset.look === 'slides' && this.list) this.setupSlides();
      this.watchView();
    }

    setupSlides() {
      const dots = Array.from(this.querySelectorAll('.ayo-sc__dot'));
      const pos = this.querySelector('[data-ayo-sc-pos]');
      const items = Array.from(this.list.querySelectorAll('.ayo-sc__item'));
      this.slides = items;
      this.idx = 0;
      const paint = (i) => {
        if (i === this.idx && items[i] && items[i].classList.contains('is-active')) return;
        this.idx = i;
        items.forEach((it, k) => it.classList.toggle('is-active', k === i));
        dots.forEach((d, k) => { d.classList.toggle('is-on', k === i); if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
        if (pos) pos.textContent = items.length > 1 ? `${i + 1} / ${items.length}` : '';
      };
      let raf = 0;
      this.list.addEventListener('scroll', () => {
        if (raf) return;
        raf = requestAnimationFrame(() => { raf = 0; const w = items[0] ? items[0].offsetWidth : 1; paint(Math.max(0, Math.min(items.length - 1, Math.round(Math.abs(this.list.scrollLeft) / w)))); });
      }, { passive: true });
      this.idx = -1; paint(0);
      if (items.length < 2) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.dataset.autoplay !== 'true' || reduce) return;
      // The fill animation on the active dot is the timer: when it ends, move to the next card.
      this.classList.add('is-auto');
      this.addEventListener('animationend', (e) => { if (e.target.classList && e.target.classList.contains('ayo-sc__dot') && e.target.classList.contains('is-on')) this.goTo((this.idx + 1) % items.length); });
      const pause = () => { clearTimeout(this.resumeT); this.classList.add('is-paused'); };
      const resume = (ms) => { clearTimeout(this.resumeT); this.resumeT = setTimeout(() => this.classList.remove('is-paused'), ms); };
      this.list.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') pause(); });
      this.list.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') resume(300); });
      this.list.addEventListener('touchstart', pause, { passive: true });
      this.list.addEventListener('touchend', () => resume(3500), { passive: true });
      this.addEventListener('focusin', pause);
      this.addEventListener('focusout', () => resume(1500));
    }

    goTo(i) {
      if (!this.slides || !this.slides[i]) return;
      const rtl = getComputedStyle(this.list).direction === 'rtl';
      const w = this.slides[0].offsetWidth;
      const max = this.list.scrollWidth - this.list.clientWidth;
      if (i * w > max + 2) i = i === this.idx + 1 ? 0 : Math.round(max / w);
      this.list.scrollTo({ left: (rtl ? -1 : 1) * i * w, behavior: 'smooth' });
    }

    watchView() {
      const motion = this.classList.contains('ayo-sc--motion') && !(window.Shopify && window.Shopify.designMode);
      if (!('IntersectionObserver' in window)) { this.classList.add('is-in', 'is-seen'); return; }
      // Only cards still below the screen rise in, so nothing already on screen blinks.
      if (motion && this.getBoundingClientRect().top > window.innerHeight) this.classList.add('is-ready');
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting && en.intersectionRatio > 0.15) this.classList.add('is-in');
          this.classList.toggle('is-seen', en.isIntersecting && en.intersectionRatio > 0.5);
        });
      }, { threshold: [0, 0.15, 0.5, 1] });
      this.io.observe(this);
    }

    disconnectedCallback() { if (this.io) this.io.disconnect(); clearTimeout(this.resumeT); }

    onClick(e) {
      const go = e.target.closest('[data-ayo-sc-go]');
      if (go) { this.goTo(Number(go.dataset.ayoScGo)); this.classList.add('is-paused'); clearTimeout(this.resumeT); this.resumeT = setTimeout(() => this.classList.remove('is-paused'), 4000); return; }
      const open = e.target.closest('[data-ayo-sc-sheet]');
      if (open) { this.openSheet(open); return; }
      if (e.target.closest('[data-ayo-sc-close]')) { this.dialog.close(); return; }
      const add = e.target.closest('[data-ayo-sc-add]');
      if (add && !add.disabled) this.add(add);
    }

    openSheet(btn) {
      const item = btn.closest('.ayo-sc__item');
      const tpl = item.querySelector('[data-ayo-sc-sizes]');
      if (!tpl || !this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.opener = btn;
      this.dialog.querySelector('[data-ayo-sc-sheet-title]').textContent = item.dataset.title || '';
      this.dialog.querySelector('[data-ayo-sc-sheet-sizes]').replaceChildren(tpl.content.cloneNode(true));
      this.dialog.showModal();
      document.documentElement.classList.add('ayo-lock');
    }

    async add(btn) {
      if (btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;
      btn.classList.add('is-loading');
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const fd = new FormData();
      fd.append('id', btn.dataset.ayoScAdd);
      fd.append('quantity', '1');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        fd.append('sections', cart.getSectionsToRender().map((x) => x.id));
        fd.append('sections_url', window.location.pathname);
      }
      const label = btn.textContent;
      try {
        const res = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
        const data = await res.json();
        if (data.status) throw new Error(data.description || '');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ayo-showcase', productVariantId: btn.dataset.ayoScAdd, cartData: data });
        document.dispatchEvent(new CustomEvent('ayo:cart-changed'));
        btn.classList.add('is-added');
        btn.textContent = '✓';
        if (this.dialog && this.dialog.open) {
          this.dialog.close();
          if (this.opener) { this.opener.classList.add('is-added'); this.opener.textContent = '✓'; }
        }
        if (this.dataset.after === 'drawer' && cart && typeof cart.renderContents === 'function' && data.sections) {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(data);
        } else {
          if (cart && data.sections && typeof cart.getSectionsToRender === 'function') {
            cart.classList.remove('is-empty');
            const inner = cart.querySelector('.drawer__inner'); if (inner) inner.classList.remove('is-empty');
            cart.getSectionsToRender().forEach((sec) => {
              const html = data.sections[sec.id]; if (!html) return;
              const el = sec.selector ? document.querySelector(sec.selector) : document.getElementById(sec.id); if (!el) return;
              const src = new DOMParser().parseFromString(html, 'text/html').querySelector(sec.selector || '.shopify-section');
              if (src) el.innerHTML = src.innerHTML;
            });
          }
          this.say(this.dataset.added, false);
        }
        setTimeout(() => { btn.classList.remove('is-added'); btn.textContent = label; if (this.opener && this.opener !== btn) { this.opener.classList.remove('is-added'); this.opener.textContent = '+'; } }, 2500);
      } catch (err) {
        btn.textContent = label;
        this.say(err.message || this.dataset.error, true);
      } finally {
        btn.classList.remove('is-loading');
      }
    }

    say(text, isError) {
      if (!this.msg || !text) return;
      this.msg.textContent = text;
      this.msg.classList.toggle('is-error', !!isError);
      this.msg.hidden = false;
      clearTimeout(this.msgT);
      this.msgT = setTimeout(() => { this.msg.hidden = true; }, 3000);
    }
  }
  customElements.define('ayo-showcase', AyoShowcase);
})();
